import { Box, Container, Grid, Card, CardHeader, CardContent, Skeleton } from "@mui/material";

export function RestaurantPageSkeleton() {
    return (
        <Box component="main" sx={{ flexGrow: 1 }}>
            <Container>
                <Box mb={2}>
                    <Skeleton variant="rectangular" height={40} width={300} />
                </Box>
            </Container>
            <Container>
                <Grid container spacing={4}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Skeleton 
                            variant="rectangular" 
                            width="100%" 
                            height="400px" 
                            sx={{ borderRadius: "12px" }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Card sx={{ height: { xs: 'auto', md: '400px', borderRadius: "12px" } }}>
                            <CardHeader
                                sx={{ paddingBottom: 0 }}
                                action={
                                    <Box display="flex" gap={1}>
                                        <Skeleton variant="rectangular" width={80} height={32} />
                                        <Skeleton variant="rectangular" width={40} height={32} />
                                    </Box>
                                }
                                title={<Skeleton variant="text" width={200} />}
                                subheader={<Skeleton variant="text" width={150} />}
                            />
                            <CardContent
                                sx={{
                                    paddingTop: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1
                                }}>
                                <Skeleton variant="text" width="80%" />
                                <Skeleton variant="text" width="60%" />
                                <Skeleton variant="text" width="70%" />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid size={12}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Box display="flex" gap={2}>
                                <Skeleton variant="text" width={60} />
                                <Skeleton variant="text" width={80} />
                            </Box>
                        </Box>
                        <Box mt={2}>
                            <Skeleton variant="rectangular" height={200} />
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}